// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonSlidableMenu{
    display: flex;
    align-items: center;
    /*background: #F3F6FF;*/
    background: #F0F2FF;
    border-radius: 20px;
    padding: 2px 2px;
}

.commonSlidableMenu_wrapper{
    padding: 4px 18px;
    background-color: #f9f9f6;
}

/*.bottomMenu{
    display: flex;
    justify-content: center;
    gap: 26px;
    background: #F3F6FF;
    border-radius: 8px;
    padding: 2px;
}
*/
.commonSlidableMenu_button{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    height: 28px;
    
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 22px;
    color: #212633;
    border: 1px solid transparent;
}

.commonSlidableMenu_button--active{
    background: #FFFFFF;
    border: 1px solid #E2E9FC;
    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);
    border-radius: 8px;
}

.commonSlidableMenu_scroll{
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.commonSlidableMenu_items{
    position: absolute;
    display: flex;
    transition-duration: 400ms;
}

.commonSlidableMenu_item{
    /*padding: 0 100px;*/
    /*border: 1px solid #000;*/
    border-right: 1px solid #989FC91F;
    padding: 0px 26px;
}

.commonSlidableMenu .AnimatedMenuItem_items{
    background: transparent;
    background-color: transparent;
}

.commonSlidableMenu_arrows{
    display: flex;
    gap: 4px;
}

.commonSlidableMenu_arrow{
    width: 24px;
    height: 24px;

    display: flex;
    justify-content: center;
    align-items: center;

    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-size: 0;

    opacity: 0.7;
    margin: 4px;
    transition: opacity 0.2s ease;
}

.commonSlidableMenu_arrow:hover{
    opacity: 1;
}

.commonSlidableMenu_arrow_left{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.commonSlidableMenu--noScroll {

}`, "",{"version":3,"sources":["webpack://./src/components/slidableMenu/SlidableMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;;;;;;;CAQC;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;;IAEZ,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,wFAAwF;IACxF,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,4BAA4B;IAC5B,sBAAsB;IACtB,yDAAsD;IACtD,YAAY;;IAEZ,YAAY;IACZ,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;;AAEA","sourcesContent":[".commonSlidableMenu{\n    display: flex;\n    align-items: center;\n    /*background: #F3F6FF;*/\n    background: #F0F2FF;\n    border-radius: 20px;\n    padding: 2px 2px;\n}\n\n.commonSlidableMenu_wrapper{\n    padding: 4px 18px;\n    background-color: #f9f9f6;\n}\n\n/*.bottomMenu{\n    display: flex;\n    justify-content: center;\n    gap: 26px;\n    background: #F3F6FF;\n    border-radius: 8px;\n    padding: 2px;\n}\n*/\n.commonSlidableMenu_button{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 24px;\n    height: 28px;\n    \n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 22px;\n    color: #212633;\n    border: 1px solid transparent;\n}\n\n.commonSlidableMenu_button--active{\n    background: #FFFFFF;\n    border: 1px solid #E2E9FC;\n    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);\n    border-radius: 8px;\n}\n\n.commonSlidableMenu_scroll{\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.commonSlidableMenu_items{\n    position: absolute;\n    display: flex;\n    transition-duration: 400ms;\n}\n\n.commonSlidableMenu_item{\n    /*padding: 0 100px;*/\n    /*border: 1px solid #000;*/\n    border-right: 1px solid #989FC91F;\n    padding: 0px 26px;\n}\n\n.commonSlidableMenu .AnimatedMenuItem_items{\n    background: transparent;\n    background-color: transparent;\n}\n\n.commonSlidableMenu_arrows{\n    display: flex;\n    gap: 4px;\n}\n\n.commonSlidableMenu_arrow{\n    width: 24px;\n    height: 24px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-image: url('../../assets/chevron-left.svg');\n    font-size: 0;\n\n    opacity: 0.7;\n    margin: 4px;\n    transition: opacity 0.2s ease;\n}\n\n.commonSlidableMenu_arrow:hover{\n    opacity: 1;\n}\n\n.commonSlidableMenu_arrow_left{\n    background-image: url('../../assets/chevron-right.svg');\n}\n\n.commonSlidableMenu--noScroll {\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
